import React from 'react';

import './App.scss';
import Header from './Components/Header'
import TopSection from './Components/Top-Section/index'
import SecondSection from './Components/Second-Section/index'
import ThirdSection from './Components/Third-Section/index'

import Footer from './Components/Footer/index'

export default () => (
    <>
    <Header />
    <main>
    <TopSection />
    <SecondSection />
    <ThirdSection />
    </main>
    <Footer />
    </>
  );


